<template>
  <div>
    <div id="modal" class="modal is-active" style="z-index:99999;" v-if="!contentLoaded">
      <div class="modal-background"></div>
      <div class="modal-content has-text-centered" style="overflow: visible;width: auto;">
        <orbit-spinner :animation-duration="1200" :size="100" color="#ffffff" style="margin:auto;"/>

        <p style="color:white;margin-top:20px;">Wird geladen...</p>
      </div>
    </div>

    <section class="hero gmap gmap-section" style="top: 52px; position: absolute; width: 100%;" v-if="cookies_maps">
      <div>
        <gmap-map
          :center="center"
          :zoom="zoom"
          style="width: 100%; height: 400px;"
          class="shadow"
          :options="options"
        >
          <gmap-info-window
            :options="infoOptions"
            :position="infoWindowPos"
            :opened="infoWinOpen"
            @closeclick="infoWinOpen=false"
          >
            <router-link :to="infoContentURL">
              <span v-html="infoContent"></span>
            </router-link>
          </gmap-info-window>
          <!-- load map markers -->
          <gmap-marker
            v-for="(m,i) in content"
            :key="i"
            :position="m.address.position"
            :clickable="true"
            @click="toggleInfoWindow(m.address.position,m.address.name,m.seo.title,i,'details/' + m.seo.niceUrl)"
            :icon="m.type == 2 ? icon2 : m.type == 3 ? icon3 : m.type == 4 ? icon4 : m.type == 5 ? icon5 : icon1"
            ref="gmarker"
            :animation="0"
          ></gmap-marker>

          <!-- load current location marker -->
          <gmap-marker v-if="location" :position="myPos" :icon="bluedot"></gmap-marker>
        </gmap-map>
      </div>

      <div
        class="section is-hidden-touch"
        style="position: absolute;bottom: -20px;left:0; right:0;pointer-events: none;"
      >
        <div class="container">
          <locationSearch></locationSearch>
        </div>
      </div>
    </section>

    <section class="section" :class="cookies_maps ? 'main-fixed' : 'ohne-maps'">
      <div class="container">
        <div class="columns is-multiline is-hidden-touch">
          <div class="column is-12">
            <div class="notification is-warning" v-if="!cookies_maps">
                Sie verwenden unsere Webseite ohne Karten. Möchten Sie Google Maps aktivieren? &nbsp;
                <a @click="$store.commit('editCookies')">Einstellungen</a>
              </div>
            <div class="field is-grouped is-grouped-multiline">
              <div class="control">
                <div class="tags has-addons">
                  <span @click="filter" class="tag is-rounded is-medium cursor outlined">
                    <span class="icon">
                      <i class="fa fa-check" v-if="!filterContent"></i>
                      <i class="fas fa-times" v-else></i>
                    </span>&nbsp;Alles anzeigen
                  </span>
                </div>
              </div>
              <div
                v-for="(i, index) in allTags"
                :key="index"
                class="control"
                v-show="filterContent"
              >
                <div class="tags has-addons">
                  <span
                    @click="filterBy(i)"
                    class="tag is-rounded is-medium cursor"
                    :class="[ {'tag_reset' : (filterContentBy.indexOf(i) === -1)}, 'tag_' + i ]"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <transition-group name="list" tag="div" class="columns is-multiline is-mobile">
          <div
            v-for="(i, index) in content.slice(0, limitNumber)"
            class="column is-full-mobile-custom is-half-mobile is-one-third-tablet is-one-quarter-desktop is-one-quarter-widescreen is-one-quarter-fullhd"
            :key="index + 1"
            @mouseenter="animateMarker(index, true)"
            @mouseleave="animateMarker(index, false)"
          >
            <div class="card card-equal-height">
              <div class="card-image" v-if="i.address.image.path.length">
                <figure class="image">
                  <router-link :to="'/details/' + i.seo.niceUrl">
                    <img
                      :src="assetsBaseUrl + i.address.image.path"
                      :alt="i.address.image.credits"
                      :title="i.address.image.credits"
                    >
                  </router-link>
                </figure>
              </div>
              <div class="card-content is-primary">
                <p class="title is-5">
                  <router-link :to="'/details/' + i.seo.niceUrl">{{ i.headline }}</router-link>
                </p>
                <p
                  class="subtitle is-5"
                  v-if="i.seo.description.length"
                  style="padding-top:12px;"
                >{{ i.seo.description }}</p>
                <div class="tags" style="margin-top:12px;">
                  <span
                    v-for="(i, index) in i.tags"
                    :key="index"
                    class="tag is-rounded is-small"
                    :class="'tag_' + i"
                  ></span>
                </div>
              </div>
              <footer class="card-footer" v-if="cookies_maps">
                <p
                  class="card-footer-item cursor center-map"
                  style="flex-grow:0;"
                  @click.stop="centerMap(i.address.position)"
                >
                  <span>
                    <span class="icon">
                      <i class="fas fa-map-marked-alt"></i>
                    </span>
                  </span>
                </p>
                <p class="card-footer-item" v-if="location">
                  <span>
                    <strong>Entfernung:</strong>
                    {{ $store.getters.calcDistance(i.address.position) }} km
                  </span>
                </p>
              </footer>
            </div>
          </div>
        </transition-group>
        <div class="columns is-multiline">
          <div class="column is-12" v-if="content.length===0">
            <p class="title is-5">
              <span class="icon">
                <i class="fa fa-info-circle"></i>
              </span>&nbsp;Keine Ergebnisse zu der Auswahl
            </p>
            <p>
              <a @click="filter">Filter deaktivieren</a>
            </p>
          </div>
          <div class="column is-12 has-text-centered" v-else>
            <button
              @click="limitNumber += 12"
              v-if="contentLength > 8 && limitNumber < contentLength"
              class="button is-fullwidth is-info is-large"
            >
              <span class="icon">
                <i class="fa fa-plus-circle"></i>
              </span>
              <span>Mehr laden</span>
            </button>
          </div>
        </div>
      </div>
    </section>

    <section
      class="hero is-success is-medium"
      :style="'background-image:url(\'' + assetsBaseUrl + 'images/8290-footer-background.jpg\');background-position: center; background-size: cover;'"
    >
      <div class="hero-body">
        <div class="container">
          <div class="columns is-mobile">
            <div
              class="column is-three-fifths-desktop is-offset-one-fifth-desktop has-text-centered"
            >
              <h1 class="title">{{ seoHeadline }}</h1>
              <h2 class="subtitle">{{ seoText }}</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { OrbitSpinner } from 'epic-spinners'
import locationSearch from '../components/shared/LocationSearch.vue'
export default {
  data() {
    return {
      stopGmarkerAnimation: false,
      metaData: {
        description:
          'Alle Informationen für Ihren Urlaub im Waldviertel: Unterkünfte, Restaurants und Gasthöfe, Veranstaltungen, Ausflugziele und Kulturschätze. So wird Ihr Urlaub im Waldviertel mit Sicherheit zur schönsten Zeit des Jahres.',
        image: 'images/3892-2018-01-wwwurlaubimwaldviertelat.png',
        fbID: '1649771028438873'
      },
      limitNumber: 12,
      contentLength: 0,
      metaTitle: 'Für die schönste Zeit des Jahres',
      options: {
        disableDefaultUI: true,
        zoomControl: true
      },
      infoContent: '',
      infoContentURL: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      seoHeadline: 'Urlaub im Waldviertel',
      seoText:
        'Spaß, Entspannung und mit der Familie eine schöne Zeit verbringen: all das bietet Ihnen ein Urlaub im Waldviertel. Auf unserer Webapp finden Sie die besten Angebote für Ihren gelungenen Urlaub im Waldviertel.'
    }
  },
  methods: {
    centerMap(v) {
      this.$store.commit('setCenter', v)
      this.$store.commit('setZoom', 16)
    },
    // toggle google marker info window
    toggleInfoWindow(pos, name, title, idx, to) {
      this.infoWindowPos = pos
      this.$store.commit('setCenter', pos)
      this.infoContent = '<strong>' + name + ':</strong> ' + title
      this.infoContentURL = to
      // check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    },
    filter() {
      this.$store.dispatch('filterContent')
    },
    filterBy(v) {
      this.$store.commit('filterContentBy', v)
    },
    animateMarker(id, state) {
      if (this.content.length && this.$route.name === 'home' && this.cookies_maps) {
        if (state) {
          this.$refs.gmarker[id].$markerObject.setAnimation(1)
        } else {
          this.$refs.gmarker[id].$markerObject.setAnimation(0)
        }
      }
    }
  },
  computed: {
    // define getters
    myPos() {
      return this.$store.getters.myPos
    },
    cookies_maps() {
      return this.$store.getters.cookies_maps
    },
    zoom() {
      return this.$store.getters.zoom
    },
    center() {
      return this.$store.getters.center
    },
    assetsBaseUrl() {
      return this.$store.getters.assetsBaseUrl
    },
    icon1() {
      return this.$store.getters.icon1
    },
    icon2() {
      return this.$store.getters.icon2
    },
    icon3() {
      return this.$store.getters.icon3
    },
    icon4() {
      return this.$store.getters.icon4
    },
    icon5() {
      return this.$store.getters.icon5
    },
    filterContent() {
      return this.$store.getters.filterContent
    },
    filterContentBy() {
      return this.$store.getters.filterContentBy
    },
    bluedot() {
      return this.$store.getters.bluedot
    },
    contentLoaded() {
      return this.$store.getters.contentLoaded
    },
    location() {
      return this.$store.getters.location
    },
    allTags() {
      return this.$store.getters.allTags
    },
    content() {
      if (this.filterContent === false) {
        this.contentLength = this.$store.getters.content.length
        return this.$store.getters.content
      } else {
        this.contentLength = this.$store.getters.content.filter(el =>
          this.filterContentBy.some(s => el.tags.indexOf(s) !== -1)
        ).length
        return this.$store.getters.content.filter(el =>
          this.filterContentBy.some(s => el.tags.indexOf(s) !== -1)
        )
      }
    },
    infoOptions() {
      return this.$store.getters.infoOptions
    }
  },
  created() {
    if (this.$route.path === '/abenteuer') {
      this.$store.commit('setFilterBy', [5])
      this.metaTitle = 'Abenteuer'
    } else if (this.$route.path === '/ausflugsziele') {
      this.$store.commit('setFilterBy', [2])
      this.metaTitle = 'Ausflugsziele, die sich lohnen'
      this.seoHeadline = 'Top Ausflugsziele im Waldviertel'
      this.seoText =
        'Während Ihres Urlaubs im Waldviertel gibt es viel zu entdecken. Die schönsten Ausflugsziele des Waldviertels finden Sie auf unserer Webapp.'
    } else if (this.$route.path === '/bio') {
      this.$store.commit('setFilterBy', [12])
      this.metaTitle = 'Bio'
    } else if (this.$route.path === '/einkaufen') {
      this.$store.commit('setFilterBy', [6])
      this.metaTitle = 'Einkaufen'
    } else if (this.$route.path === '/gasthaeuser') {
      this.$store.commit('setFilterBy', [10])
      this.metaTitle = 'Gasthäuser'
    } else if (this.$route.path === '/heurige') {
      this.$store.commit('setFilterBy', [13])
      this.metaTitle = 'Heurige'
    } else if (this.$route.path === '/hotels') {
      this.$store.commit('setFilterBy', [15])
      this.metaTitle = 'Hotels im Waldviertel'
      this.seoHeadline = 'Hotels im Waldviertel '
      this.seoText =
        'Erleben Sie die Gastfreundlichkeit des Waldviertels! In den Hotels des Waldviertels können Sie ihren Urlaub in der Region so richtig genießen.'
    } else if (this.$route.path === '/kaffeehaeuser') {
      this.$store.commit('setFilterBy', [14])
      this.metaTitle = 'Kaffeehäuser'
    } else if (this.$route.path === '/kulinarium') {
      this.$store.commit('setFilterBy', [16])
      this.metaTitle = 'Gut essen im Waldviertel'
      this.seoHeadline = 'Kulinarisches Waldviertel'
      this.seoText =
        'Restaurants und Wirtshäuser - das Waldviertel mit vielen kulinarischen Schätzen. Erleben Sie bei Ihrem Urlaub im Waldviertel die Region von ihrer geschmackvollsten Seite.'
    } else if (this.$route.path === '/kunst-kultur') {
      this.$store.commit('setFilterBy', [9])
      this.metaTitle = 'Kunst und kultur'
    } else if (this.$route.path === '/museen') {
      this.$store.commit('setFilterBy', [11])
      this.metaTitle = 'Eintauchen in die Geschichte'
      this.seoHeadline = 'Eintauchen in die Geschichte'
      this.seoText =
        'Burgen, Schlösser und Klöster: das Waldviertel ist eine Region mit langer Geschichte. Entdecken Sie die interessantesten Angebote für Ihren Urlaub im Waldviertel auf unserer Webapp.'
    } else if (this.$route.path === '/sport') {
      this.$store.commit('setFilterBy', [7])
      this.metaTitle = 'Sport'
    } else if (this.$route.path === '/stifte-kloester-schloesser') {
      this.$store.commit('setFilterBy', [8])
      this.metaTitle = 'Stifte, Klöster und Schlösser'
    } else if (this.$route.path === '/stories') {
      this.$store.commit('setFilterBy', [1])
      this.metaTitle = 'Das Besondere am Waldviertel'
      this.seoHeadline = 'Das Besondere am Waldviertel'
      this.seoText =
        'Das Waldviertel beeindruckt mit schöner Landschaft und interessanten Menschen. Auf unserer Webapp finden Sie tolle Storys über die Region und die Menschen die hier leben.'
    } else if (this.$route.path === '/unterkuenfte') {
      this.$store.commit('setFilterBy', [4])
      this.metaTitle = 'Unterkünfte: Gut schlafen im Waldviertel'
      this.seoHeadline = 'Unterkünfte im Waldviertel'
      this.seoText =
        'Gemütlich oder stilvoll, urig oder modern – Sie haben die Wahl! Auf unserer Webapp finden Sie genau die richtige Unterkunft für Ihren Urlaub im Waldviertel.'
    } else if (this.$route.path === '/veranstaltungen') {
      this.$store.commit('setFilterBy', [3])
      this.metaTitle = 'Veranstaltungen im Waldviertel'
      this.seoHeadline = 'Veranstaltungen im Waldviertel'
      this.seoText =
        'Im Waldviertel ist viel los! Während Ihres Urlaubs im Waldviertel gibt es viel zu erleben. Auf unserer Webapp finden Sie die Veranstaltungen und Events für jeden Geschmack.'
    } else if (this.$route.path === '/wellness') {
      this.$store.commit('setFilterBy', [17])
      this.metaTitle = 'Entspannung für Körper und Geist'
      this.seoHeadline = 'Wellness im Waldviertel'
      this.seoText =
        'Das Waldviertel hat sich zu einer der besten Region für Wellness in Österreich entwickelt. Erleben Sie bei Ihrem Urlaub in der Region das großartige Angebot für die Entspannung von Körper und Geist.'
    }
  },
  components: {
    locationSearch,
    OrbitSpinner
  },
  metaInfo() {
    if (!this.metaData) return {}
    if (!this.metaTitle) return {}
    return {
      title: this.metaTitle,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.metaData.description
        },
        { vmid: 'twitter:card', name: 'twitter:card', value: 'summary' },
        { vmid: 'og:title', property: 'og:title', content: this.metaTitle },
        { vmid: 'og:type', property: 'og:type', content: 'article' },
        { vmid: 'og:url', property: 'og:url', content: window.location.href },
        {
          vmid: 'og:image',
          property: 'og:image',
          content: this.assetsBaseUrl + this.metaData.image
        },
        { vmid: 'og:image:width', property: 'og:image:width', content: 1200 },
        { vmid: 'og:image:height', property: 'og:image:height', content: 630 },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: this.metaData.description
        },
        {
          vmid: 'fb:app_id',
          property: 'fb:app_id',
          content: this.metaData.fbID
        }
      ]
    }
  }
}
</script>

<style scoped>
@media screen and (max-width: 500px) {
  .is-full-mobile-custom {
    width: 100% !important;
  }
}

.list-move {
  transition: all 600ms ease-in-out 50ms;
}

.list-enter-active {
  transition: all 300ms ease-out;
}

.list-leave-active {
  transition: all 200ms ease-in;
  position: absolute;
  z-index: 0;
}
.list-enter,
.list-leave-to {
  opacity: 0;
}
.list-enter {
  transform: scale(0.9);
}

.card-content {
  padding: 1rem;
}

.center-map {
  display: none;
}

.shadow {
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1);
}

@media all and (min-height: 812px) {
  .gmap {
    position: fixed !important;
    left: 0px;
    width: 100%;
    z-index: 28;
  }
  .center-map {
    display: flex;
  }
}

.main-fixed {
  margin-top: 440px;
}

.ohne-maps {
  margin-top: 40px;
}

@media all and (max-width: 1023px) {
  .gmap-section {
    top: 104px !important;
  }
  .main-fixed {
    margin-top: 480px;
  }

  .ohne-maps {
  margin-top: 90px;
}
}
</style>
